//
//
//
//
//
//
//
//
//
//
//
//

import Emitter from '@/utils/emitter';
export default {
  name: 'GRadio',
  mixins: [Emitter],
  inject: {
    elFormItem: {
      default: '',
    },
  },
  props: {
    value: {
      type: [Array, String],
      default: null,
    },
    list: {
      type: Array,
      default: [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value || '';
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    value() {
      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
    },
  },
};
